import React from 'react';
import classes from './ProfileInfoItem.module.scss';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const ProfileInfoItem = ({label, value}) => {
    return (
        <div className={classes['info-wrapper']}>
            <div className={classes['profile-info-label']}>{label}</div>
            {
                value || value === "" ?
                    <div className={classes['profile-info-value']}>{value || '-'}</div> :
                    <Skeleton />
            }
        </div>
    );
};

export default ProfileInfoItem;